import { Box, Grid, Typography, makeStyles } from '@material-ui/core'
import { FancySwitch } from 'common/atoms/FancySwitch/FancySwitch'
import { FunctionComponent, useEffect, useState } from 'react'
import { useTheme } from 'styled-components/macro'
import { observer } from 'mobx-react'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { Button } from 'common/atoms/Button/Button'
import { useEditProfile } from 'pages/profile/hooks/useEditProfile'
import { UpdateMainGoalsBox } from 'pages/profile/styled'
import CustomCheckbox from 'common/atoms/CheckBox/CheckBox'
import { QuestionAnswer } from 'common/types'

const goals = [
  { inQuestion: 'Seek Capital/Investment', inAnswer: 'no' },
  { inQuestion: 'Build my professional network', inAnswer: 'no' },
  { inQuestion: 'Source New Business Clients', inAnswer: 'no' },
  { inQuestion: 'Find a Job', inAnswer: 'no' },
  { inQuestion: 'Hire Talent', inAnswer: 'no' },
  { inQuestion: 'Find Tech Solutions', inAnswer: 'no' },
  { inQuestion: 'Belonging, Support or Community', inAnswer: 'no' },
  { inQuestion: 'Professional Development', inAnswer: 'no' },
  { inQuestion: 'Seeking a Mentor', inAnswer: 'no' },
  { inQuestion: 'Obsidi Academy', inAnswer: 'no' }
]

const useStyles = makeStyles(th => ({
  gridItem: {
    '&.MuiGrid-spacing-xs-2 > .MuiGrid-item': {
      padding: '0px'
    }
  }
}))

export const EditMainGoals: FunctionComponent = observer(() => {
  const theme = useTheme()
  const classes = useStyles()
  const { isDevice } = useScreenSizes()
  const { backendUser } = useAuth()
  const [updateButtonEnabled, setUpdateButtonEnabled] = useState(false)
  const [newMainGoals, setNewMainGoals] = useState(goals as any)
  const [newGoals, setNewGoals] = useState<QuestionAnswer[]>(backendUser?.onboardingQuestions)
  const { completeEditOnboarding, updatedQuestionAnswers } = useEditProfile()

  const findAnswer = question => {
    const answer = backendUser.onboardingQuestions?.find(ans => ans.question === question)
    return answer?.answer
  }
  const [showGoals, setShowGoals] = useState(false)

  const handleCheckBoxClick = (e, inQuestion?) => {
    setUpdateButtonEnabled(true)

    setNewMainGoals(prevData => {
      const updatedMainGoals = prevData.map(item => {
        if (item.inQuestion === inQuestion) {
          return { ...item, inAnswer: e.target.checked === true ? 'yes' : 'no' }
        } else {
          return item
        }
      })

      setNewMainGoals(updatedMainGoals)
      setNewGoals(prevData => {
        const updatedData = prevData.map(item => {
          switch (item.question) {
            case 'What Do You Want To Accomplish at Obsidi?':
              return { ...item, answer: JSON.stringify(updatedMainGoals) }

            default:
              return item
          }
        })
        return updatedData
      })
    })
  }

  const handleShowGoalsSwitch = e => {
    setUpdateButtonEnabled(true)

    setNewGoals(prevData => {
      const updatedData = prevData.map(item => {
        switch (item.question) {
          case 'Show Goals':
            return { ...item, answer: e.toString() }
          default:
            return item
        }
      })
      return updatedData
    })
  }
  useEffect(() => {
    setShowGoals(findAnswer('Show Goals') === 'true')
    const mainGoals = findAnswer('What Do You Want To Accomplish at Obsidi?')
    const parsedData = mainGoals ? JSON.parse(mainGoals) : []

    setNewMainGoals(prevData => {
      return prevData.map(item => {
        const matchingGoal = parsedData?.find(q => q?.inQuestion?.trim() === item.inQuestion)
        if (matchingGoal) {
          return { ...item, inAnswer: matchingGoal?.inAnswer }
        } else {
          return item
        }
      })
    })
  }, [])

  return (
    <Box display="flex" flexDirection="column" width="100%" zIndex={0} marginTop="-20px">
      <Box
        position={'relative'}
        display="flex"
        justifyContent="flex-end"
        flexDirection="row"
        mr="1rem"
        top={'-20px'}
        alignSelf="flex-end"
      >
        <Typography variant="subtitle2">
          <Box color={theme.colors.accent} mr="1rem">
            Show
          </Box>
        </Typography>
        <FancySwitch
          width="4.75rem"
          height="1.688rem"
          state={showGoals}
          onChange={e => {
            setShowGoals(e)
            handleShowGoalsSwitch(e)
          }}
          currentStateLabel={showGoals => (
            <>
              {showGoals ? (
                <Typography variant="overline">
                  <Box color={theme.colors.accent1}>ON</Box>
                </Typography>
              ) : (
                <Typography variant="overline">
                  <Box color={theme.colors.accent1}>OFF</Box>
                </Typography>
              )}
            </>
          )}
        />
      </Box>
      <Box
        width={isDevice ? '19.5rem' : '51.813rem'}
        borderRadius="1rem"
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        flexDirection="column"
        gridGap="32px"
      >
        <Box width="100%" height="100%" overflow={'auto'}>
          <Grid container className={classes.gridItem}>
            {newMainGoals?.map((x, index) => (
              <Grid item xs={12} sm={6} md={4} key={x.inQuestion}>
                <Box display="flex" padding="0.19rem 0" alignItems={'center'} key={x.inQuestion}>
                  <CustomCheckbox
                    checked={x.inAnswer === 'yes'}
                    key={x.inQuestion}
                    onChange={e => {
                      handleCheckBoxClick(e, x.inQuestion)
                    }}
                  />
                  <Box display="flex" flexDirection="column">
                    <Typography variant="overline">{x.inQuestion}</Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  )
})

export default EditMainGoals
